import React, { useState, createContext } from 'react';

export const EventsDataContext = createContext();

export const EventsDataProvider = ({ children }) => {
  const [optionsVisibility, setOptionsVisibility] = useState({
    share: false,
    addWardrobe: false,
    optionsButton: false,
    printMode: false,
  });

  return (
    <EventsDataContext.Provider value={{ optionsVisibility, setOptionsVisibility }}>
      {children}
    </EventsDataContext.Provider>
  );
};
